module.exports = __webpack_public_path__ + "static/couture03-09c7254a29e40a98e36e65cb2790bad4.png";